module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('h1', {
    staticClass: "headB"
  }, [_vm._v("LIST OF ILLUSTRATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRIT")]), _vm._v(" ‘K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATIE")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ING")]), _vm._v("’ P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOTOGRAPHED BY")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IR")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILLIAM")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROOKES")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("I. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AGE OF")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRITS")]), _vm._v(", S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRIT")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOTOGRAPHS, ETC")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("II. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LASTER")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTS OF")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LUSKI’S")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AX")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRIT")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANDS")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("III. L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVITATING")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANDKERCHIEF")]), _vm._v(", A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTOMATICALLY")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOTOGRAPHED AT A")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDI")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CHNEIDER")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ÉANCE")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("IV. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RUDE")]), _vm._v(" ‘H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v("’ P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOTOGRAPHED AT A")]), _vm._v(" ‘M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARGERY")]), _vm._v("’ S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ÉANCE")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("V. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HARLES")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LDRED’S")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AKED")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAIR AND")]), _vm._v(" ‘P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROPERTIES")]), _vm._v("’")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("VI. M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS")]), _vm._v(". M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELLON AND HER")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRIT")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UIDE")]), _vm._v(" ‘G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EORDIE")]), _vm._v("’")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("VII. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARTOON OF")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENRY")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LADE AND")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROFESSOR")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AY")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANKESTER")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("VIII. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVER AND")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HREE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AGES OF")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YLVESTRE’S")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATALOGUE OF")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AKE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPARATUS FOR")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AKE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EDIUMS")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("IX. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("USSAIN AND")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLUNTEERS")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OING THE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRE")]), _vm._v("-W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALK AT")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARSHALTON")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("X. R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EGINALD")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DCOCK")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OING THE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRE")]), _vm._v("-W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALK AT")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRA")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALACE")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("XI. B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROADCASTING FROM THE")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUNTED")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANOR")]), _vm._v(", M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EOPHAM")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("XII. E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBLEMATICAL")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INDING OF")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUTHCOTT")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANUSCRIPT")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("XIII. G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAPH")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOWING")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARIATIONS IN")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EMPERATURE AT")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ÉANCE WITH")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISS")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TELLA")]), _vm._v(" C.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("XIV. L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ABORATORY")]), _vm._v(", S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ÉANCE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOM, ETC., OF")]), _vm._v(" U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NIVERSITY OF")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONDON")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNCIL FOR")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SYCHICAL")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NVESTIGATION")])]), _vm._v(" "), _c('h1', {
    staticClass: "headB"
  }, [_vm._v("ILLUSTRATIONS IN THE TEXT")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("A S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ÉANCE WITH THE")]), _vm._v(" "), _c('em', [_vm._v("baquet,")]), _vm._v(" T "), _c('span', {
    staticClass: "small"
  }, [_vm._v("IME OF")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESMER")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RRANGEMENT OF")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URNITURE AND")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AY-OUT OF")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOM AT")]), _vm._v(" ‘R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSALIE")]), _vm._v("’ S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ÉANCE")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("‘T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELEPATHA")]), _vm._v("’ C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARDS")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESIGNED BY")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARRY")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RICE FOR")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTING")]), _vm._v(" ‘E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XTRA-SENSORY")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERCEPTION’")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4aa31f25","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/fm3.vue
// module id = 69
// module chunks = 0